import { useDialog } from 'primevue/usedialog'
import CheckoutPhoneVerificationModal from '~/components/Verification/CheckoutPhoneVerificationModal.vue'
import type { CheckoutPhoneVerificationInput } from '~/resources/graphql/graphql'
import { useI18n } from 'vue-i18n'

export type CheckoutPhoneVerificationModalResult =
    CheckoutPhoneVerificationInput & {
        phoneLabel: string
    }

type CheckoutPhoneVerificationModalOptions = {
    initialMessage?: string
    previousVerification?: CheckoutPhoneVerificationModalResult
}

export function useCheckoutPhoneVerificationModal(): (
    options?: CheckoutPhoneVerificationModalOptions
) => Promise<CheckoutPhoneVerificationModalResult | undefined> {
    const dialog = useDialog()
    const { t } = useI18n({ useScope: 'global' })

    return options => {
        return new Promise(resolve => {
            let verification: CheckoutPhoneVerificationModalResult | undefined =
                undefined

            const instance = dialog.open(CheckoutPhoneVerificationModal, {
                props: {
                    header: t('checkout.phoneVerificationHeader'),
                    modal: true,
                    pt: {
                        root: {
                            class: 'w-full h-max-md:h-full max-h-full !rounded-none md:h-auto md:!w-[40rem]'
                        },
                        header: {
                            class: '!rounded-none'
                        },
                        content: {
                            class: '!rounded-none flex-1 '
                        }
                    },
                    ptOptions: {
                        mergeProps: true
                    }
                },
                data: {
                    initialMessage: options?.initialMessage,
                    initialToken: options?.previousVerification?.token,
                    initialPhoneLabel: options?.previousVerification?.phoneLabel
                },
                emits: {
                    onDone: (payload: CheckoutPhoneVerificationModalResult) => {
                        verification = payload
                        instance.close()
                    },
                    onCancel: () => {
                        instance.close()
                    }
                },
                onClose: () => {
                    resolve(verification)
                }
            })
        })
    }
}
